export default __webpack_public_path__ + "static/media/hotline.0f218297.svg";